import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { PopupSuperBidsComponent } from '../../modals/popup-super-bids/popup-super-bids.component';
import { MatDialog } from '@angular/material/dialog';
import { IAnimal } from 'src/app/models/animal';
import { StorageService } from 'src/app/services/storage.service';
import { PopupLoginComponent } from '../../modals/popup-login/popup-login.component';
import * as confetti from 'canvas-confetti';
import { StreamingService } from 'src/app/services/streaming.service';
import { IOpenedSchedule } from 'src/app/models/transactions';

@Component({
  selector: 'app-super-bid-button',
  templateUrl: './super-bid-button.component.html',
  styleUrls: ['./super-bid-button.component.scss']
})
export class SuperBidButtonComponent implements OnInit {
  @Input() animal_obj: IAnimal = {} as IAnimal;

  constructor(
    private storage: StorageService,
    private dialog: MatDialog,
    private renderer2: Renderer2,
    private elementRef: ElementRef,
    private streaming: StreamingService
  ) {}

  current_bid = 0;
  super_bid_value = 0;

  ngOnInit(){
    this.super_bid_value = this.animal_obj.super_bid;

    let opened_schedule: IOpenedSchedule = {} as IOpenedSchedule
    if(this.streaming.auctions) opened_schedule = Object.assign({}, this.streaming.auctions.length > 0 ? this.streaming.auctions[0] : {})
    this.current_bid = opened_schedule.transaction.auction_bid.value + opened_schedule.increment;

    this.streaming.watchSocket().subscribe({
      next: (data) => {
        if(this.streaming.auctions) opened_schedule = Object.assign({}, this.streaming.auctions.length > 0 ? this.streaming.auctions[0] : {})
        this.current_bid = opened_schedule.transaction.auction_bid.value + opened_schedule.increment;
      },
    });
  }

  openPopupSuperBid() {
    // this.surprise()

    if (!this.storage.token || this.storage.token === '') {
      this.openPopuplogIn();
      return;
    }

    const dialogRef = this.dialog.open(PopupSuperBidsComponent, {
      width: '90%',
      maxWidth: '500px',
      disableClose: true,
      data: {
        animal_obj: this.animal_obj,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.surprise()
        // this.eventSocket.emit(true);
      }
    });
  }

  surprise(){
    const canvas = this.renderer2.createElement('canvas');
    this.renderer2.appendChild(this.elementRef.nativeElement, canvas);

    const myConfetti = confetti.create(canvas, { resize: true });

    const duration = 10 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = {
      startVelocity: 30,
      particleCount: 280,
      spread: 360,
      ticks: 300,
      zIndex: 0,
      size: 100,
      colors: ['#d83030', '#fed800', '#ebb61d', '#f1b40d', '#f6e810', '#4cc933'],
    };

    function randomInRange(min: any, max:any) {
      return Math.random() * (max - min) + min;
    }

    const interval: any = setInterval(function() {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        clearInterval(interval);

        // Remove canvas element after animation completes
        canvas.parentNode?.removeChild(canvas);
        return;
      }

      const particleCount = 50 * (timeLeft / duration);
      // since particles fall down, start a bit higher than random
      myConfetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
      myConfetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
    }, 250);
  }


  openPopuplogIn() {
    const popupLoginRef = this.dialog.open(PopupLoginComponent, {
      width: '90%',
      maxWidth: '400px',
    });
    popupLoginRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        // this.eventSocket.emit(false);
      }
    });
  }
}
